import Service from '@ember/service';

import type { Scope, SeverityLevel } from '@sentry/ember';
import * as Sentry from '@sentry/ember';

export default class SentryService extends Service {
  withScope(scopeFn: (cb: Scope) => unknown): void {
    Sentry.withScope(scopeFn);
  }

  captureMessage(msg: string, level: SeverityLevel = 'info'): void {
    Sentry.captureMessage(msg, level);
  }

  captureException(error: unknown, captureContext?: Record<string, unknown>): void {
    Sentry.captureException(error, captureContext);
  }
}

declare module '@ember/service' {
  interface Registry {
    sentry: SentryService;
  }
}
